import React, { ChangeEvent } from "react";
import DictionaryItem from "../../../../models/dictionary-item";
import { GetRequest } from "./common";
import { IAction } from "./common-actions";
import { IWidgetState } from "./common-reducer";
import ActionType from "../../../../models/enums/action-type";

interface props {
    inputPlaceholder: string,
    options: DictionaryItem[],
    selectItem: string,
    inputClass: string,
    arrowLeft: number,
    arrowTop: number,
    size: string,
    value: string,
    action1: React.Dispatch<IAction>,
    action2: React.Dispatch<IAction>,
    action3: React.Dispatch<IAction>,
    action4: React.Dispatch<IAction>,
    action5: React.Dispatch<IAction>,
    action6?: React.Dispatch<IAction>,
    action7?: React.Dispatch<IAction>,
    action8?: React.Dispatch<IAction>,
    state: IWidgetState,
    disabled?: boolean
}

interface state {
    inputValue: string,
    showDropdown: boolean,
}

class InputSelect extends React.Component<props, state> {
    state: state = {
        inputValue: this.props.value,
        showDropdown: false,
    }

    componentDidMount() { document.addEventListener('click', this.handleOutsideClick); }
    componentWillUnmount() { document.removeEventListener('click', this.handleOutsideClick); }

    handleOutsideClick = (event: any) => {
        if (!event.target.classList.contains(this.props.inputClass) && !event.target.classList.contains("inputSelectArrow")) {
            this.setState({ showDropdown: false });
        }
    }

    handleInputClick() {
        if (this.props.options != null && this.props.options.length > 1) {
            this.setState({ showDropdown: !this.state.showDropdown });
        }
    }

    handleInputChange(e: ChangeEvent<HTMLInputElement>) {
        this.setState({ inputValue: e.currentTarget.value, showDropdown: true });
    }

    render() {
        if (this.state.showDropdown && !this.props.disabled) {
            return (
                <>
                    {this.renderInputSelect()}
                    {this.renderDropdown()}
                </>
            )
        }
        else {
            return (
                <>
                    {this.renderInputSelect()}
                </>
            )
        }
    }

    renderInputSelect() {
        return (
            <>
                {this.props.options != null && this.props.options.length > 1 && <span className="arrow down inputSelectArrow" style={{ position: "absolute", left: `${this.props.arrowLeft}px`, top: `${this.props.arrowTop}px` }} onClick={() => this.handleInputClick()}></span>}
                <input type="text" value={this.props.value} placeholder={this.props.inputPlaceholder} className={this.props.inputClass}
                    onClick={() => this.handleInputClick()}
                />
            </>
        )
    }

    renderDropdown() {
        //const filteredOptions = this.props.options.filter(option => option.description.trim().toLowerCase().includes(this.state.inputValue.trim().toLowerCase())).sort(function(a, b) { return a.description.localeCompare(b.description); });
        //console.log(filteredOptions);
        return (
            <div className={`${this.props.size}-selectContainer`}>
                {
                    this.props.options.map(option => {
                        return (
                            <div className={`${this.props.size}-selectOption`} key={Math.random()} onClick={() => {
                                this.setState({ inputValue: option.description, showDropdown: false });                           
                                if (this.props.selectItem === "REGION") {
                                    this.props.action1({ type: ActionType.setRegionCode, payload: { selectedRegionCode: option.code } });
                                    this.props.action2({ type: ActionType.setRegionDescription, payload: { selectedRegionDescription: option.description } });

                                    if (this.props.state.selectedSpecialisationCode) {
                                        const firstRequest = GetRequest(this.props.state.slotInterval, this.props.state.today, this.props.state.lastPossibleDate, option.code, this.props.state.selectedSpecialisationCode, this.props.state.selectedClinicCode);
                                        this.props.action1({ type: ActionType.setRequest, payload: { request: firstRequest } });
                                    }
                                }
                                else if (this.props.selectItem === "SPECIALISATION") {
                                    const specialisation: any = this.props.state.aggregatedDataToDisplay[this.props.state.aggregatedDataToDisplay.findIndex((x: {additionalDesc: string}) => x.additionalDesc === option.additionalDesc)];
                                    const clinic = specialisation.clinics[0];
                                    this.props.action1({ type: ActionType.setSpecialisationCode, payload: { selectedSpecialisationCode: option.code } });
                                    this.props.action2({ type: ActionType.setSpecialisationDescription, payload: { selectedSpecialisationDescription: option.additionalDesc } });
                                    this.props.action3({ type: ActionType.setAvailableDays, payload: { availableDays: clinic.days } });
                                    this.props.action4({ type: ActionType.setSelectedDate, payload: { selectedDate:  new Date(clinic.days[0].date) } });
                                    this.props.action5({ type: ActionType.setRegionCode, payload: { selectedRegionCode: clinic.regionCode } });
                                    this.props.action6({ type: ActionType.setClinicCode, payload: { selectedClinicCode: clinic.code } });
                                    this.props.action7({ type: ActionType.setClinicDescription, payload: { selectedClinicDescription: clinic.description } });
                                    this.props.action8({ type: ActionType.setClinics,  payload: { clinics: specialisation.clinics }});
                                    // if (this.props.state.selectedRegionCode) {
                                    //     const firstRequest = GetRequest(this.props.state.slotInterval, this.props.state.today, this.props.state.lastPossibleDate, this.props.state.selectedRegionCode, option.code, this.props.state.selectedClinicCode);
                                    //     this.props.action1({ type: ActionType.setRequest, payload: { request: firstRequest } });
                                    // }
                                } else if (this.props.selectItem === "CLINICS"){
                                    const specialisation: any = this.props.state.aggregatedDataToDisplay[this.props.state.aggregatedDataToDisplay.findIndex((x: {code: string}) => x.code === this.props.state.selectedSpecialisationCode)];
                                    const clinic = specialisation.clinics[specialisation.clinics.findIndex(x => x.code === option.code)];
                                    this.props.action1({ type: ActionType.setClinicCode, payload: { selectedClinicCode: option.code } });
                                    this.props.action2({ type: ActionType.setClinicDescription, payload: { selectedClinicDescription: option.description } });
                                    this.props.action3({ type: ActionType.setAvailableDays, payload: { availableDays: clinic.days } });
                                    this.props.action4({ type: ActionType.setSelectedDate, payload: { selectedDate:  new Date(clinic.days[0].date) } });
                                    this.props.action5({ type: ActionType.setRegionCode, payload: { selectedRegionCode: clinic.regionCode } });
                                }
                            }}>
                                {(this.props.selectItem === "CLINICS") ? option.description: option.additionalDesc}
                            </div>
                        )
                    })
                }

            </div>
        )
    }
}

export default InputSelect;